export function setCookie(name, value, expiryDays, domain, path, secure) {
    const exdate = new Date()
    exdate.setHours(exdate.getHours() + ((typeof expiryDays !== "number" ? 365 : expiryDays) * 24))
    document.cookie = name + '=' + value +
        ';expires=' + exdate.toUTCString() +
        ';path=' + (path || '/') +
        (domain ? ';domain=' + domain : '') +
        (secure ? ';secure' : '')
}
